import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "previews"]

  preview() {
    this.inputTarget.filesArray = Array.from(this.inputTarget.files)
    this.renderNewPreviews()
  }

  renderNewPreviews() {
    this.element.querySelectorAll("[data-new-image]").forEach((preview) => preview.remove())

    this.inputTarget.filesArray.forEach((file) => {
      if (!file.type.startsWith("image/")) return

      const reader = new FileReader()
      reader.addEventListener("load", () => {
        const preview = document.createElement("div")
        preview.dataset.newImage = "true"
        preview.className = "overflow-hidden rounded-xl border border-dashed border-[#ef002a] bg-white p-2"
        preview.innerHTML = `<img src="${reader.result}" class="h-32 w-full rounded-lg object-contain" alt="${file.name}"><p class="mt-2 truncate text-xs font-medium text-slate-600">${file.name}</p>`
        this.previewsTarget.append(preview)
      })
      reader.readAsDataURL(file)
    })
  }

  toggleRemoval(event) {
    event.target.closest("[data-attachment-id]")?.classList.toggle("opacity-40", event.target.checked)
  }
}
